import { inject, Injectable } from '@angular/core';
import { map, Observable, of } from 'rxjs';

import { GET_TIMEZONES_API_ID, TimeZonesApiService } from '@blaze-shared/platform-data-access';

import { DataProviderQuery, InputDataPackage } from '../../io-data.models';

import { DataSourceProvider } from './data-source.data-provider';

@Injectable({ providedIn: 'root' })
export class ApiCallDataProvider implements DataSourceProvider {
  private readonly timeZonesApiService = inject(TimeZonesApiService);
  readonly sourceType = 'api-call' as const;

  getDataStream({ source }: DataProviderQuery): Observable<InputDataPackage> {
    if (source.id === GET_TIMEZONES_API_ID) {
      return this.timeZonesApiService.timeZones$.pipe(
        map((data) => ({ sourceType: 'api-call' as const, data })),
      );
    }

    return of({ sourceType: 'api-call' as const, data: null });
  }
}
